import { store } from "./storage";

const KEY = "ulume_recent";
const MAX = 12;
const parse = (k) => { try { const v = JSON.parse(store.get(k) || "[]"); return Array.isArray(v) ? v : []; } catch { return []; } };

export function getRecent() { return parse(KEY); }
export function pushRecent(id) { store.set(KEY, JSON.stringify([id, ...getRecent().filter(x => x !== id)].slice(0, MAX))); }

const SKEY = "ulume_searches";
export function getSearches() { return parse(SKEY); }
export function pushSearch(q) {
  const t = q.trim(); if (!t) return;
  store.set(SKEY, JSON.stringify([t, ...getSearches().filter(x => x.toLowerCase() !== t.toLowerCase())].slice(0, 6)));
}
export function clearSearches() { store.remove(SKEY); }
